<template>
  <div>
    <v-dialog v-model="dialog" width="500" scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn x-small color="green darken-1 my-1 py-5" dark v-bind="attrs" v-on="on" text>
          <v-icon left> mdi-pencil-plus </v-icon>
          Éditer
        </v-btn>
      </template>
      <v-card :loading="loading">
        <v-card-title>{{ titre }} </v-card-title>
        <v-card-text style="height: 80vh">
          <v-container>
            <template v-for="(header, index) in headers">
              <v-textarea
                :key="index"
                dense
                class="text-wrap mb-3"
                style="max-width: 100% !important"
                auto-grow
                rows="1"
                hide-details="auto"
                :outlined="true"
                :messages="header.label"
                v-bind:value="testIfitIsADate(data[header.nomVariable])"
                v-on:input="
                  change = true;
                  data[header.nomVariable] = $event;
                "
              ></v-textarea>
            </template>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            tile
            color="blue lighten-1"
            dark
            v-if="change && !loading"
            @click="
              change = false;
              $emit('dataSave', data);
            "
          >
            <v-icon left> mdi-cloud-upload-outline </v-icon>
            Sauvegarder
          </v-btn>
          <v-btn
            v-if="!loading"
            tile
            color="green lighten-1"
            dark
            @click="
              change = false;
              $emit('dataSaveToFC', data);
            "
          >
            <v-icon left> mdi-cloud-upload-outline </v-icon>
            Ajouter au fichier client
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "BcdForm",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    titre: {
      default: "Titre",
    },
    btnTitle2: {
      default: "Title22",
    },
    btnTitle: {
      default: "Click Me",
    },
    data: {
      default: {},
    },
    custumHeaders: {
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    change: false,
    dialog: false,
  }),
  methods: {

    testIfitIsADate(date) {
      const regex = new RegExp("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])", "g");
      if (regex.test(date) && String(date).length == 10) {
        return this.formatDate(date);
      } else {
        return date;
      }
    },
    formatDate(date) {
      if (!date) return null;
      var da = new Date(date);
      const [year, month, day] = [
        da.getUTCFullYear(),
        ("0" + (da.getUTCMonth() + 1)).slice(-2),
        ("0" + da.getUTCDate()).slice(-2),
      ];
      return `${day}/${month}/${year}`;
    },
  },
  computed: {
    headers() {
      if (this.custumHeaders.length == 0) {
        return this.data == 0
          ? []
          : Object.keys(this.data).map((e) => {
              return { nomVariable: e, label: e };
            });
      } else {
        return this.custumHeaders;
      }
    },
  },
};
</script>

<style></style>
